import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { PageFactory } from '../index';
import { connect } from "react-redux";
import BreadCrumbs, { SubLinks } from '../../BreadCrumbs';
import { isArchivePage } from '../components/Utils';
import ArchiveFactory from './ArchiveFactory';
import { PermissionRoute } from "../../Permissions";
import { convertTreeToList } from '../../MainNav';
import { buildMapLinks } from '../../MainNav/components';


const mapStateToProps = (state) => {
  return {
    tree: state.staticPage.menuTree.organisation,
    links: state.staticPage.routes.organisation,
    labelMap: state.staticPage.labelMap.organisation,
  };
};
const mapDispatchToProps = null;


const OrganisationRoutes = ({ className = '', tree, links, labelMap, Home }) => {
  const treeLinks = convertTreeToList(buildMapLinks(tree));
  let nrSiblings = (tree.children || []).filter(item => item.id !== undefined).length - 1;
  if (nrSiblings < 0) {
    nrSiblings = 0; // ensure sibling count is not negative
  }
  console.log("OrganisationRoutes()", links, treeLinks, "tree:", tree, "nrSiblings:", nrSiblings);
  const routes = links.map((link, index) => {
    if (index === 0) {
      return null;
    }
    const { url, label } = link;
    let resource = link.resource;
    if (!resource) {
      const found = treeLinks.find(item => item.id === link.id);
      if (found) {
        resource = found.resource;
      }
    }
    const data = link.data || {};
    const type = data ? data.type : link.type;
    // Archive removed
    // -- old --
    // const Component = isArchivePage(type)
    //   ? ArchiveFactory('organisation', url, 'Archiv: Organisation')
    //   : PageFactory(url, label, type, null, null, link, { links, tree, nrSiblings });
    // -- new --
    if (isArchivePage(type)) {
      // Archive pages are no longer supported, so redirect to a default page or handle accordingly
      // For now, we just return null to skip rendering this route
      return null;
    }
    const Component = PageFactory(url, label, type, null, null, link, { links, tree, nrSiblings });
    return (
      <PermissionRoute
        resource={resource}
        key={index}
        exact={!isArchivePage(type)}
        path={url}
        component={Component}
      />
    );
  });
  return (
    <div className={className}>
      <BreadCrumbs
        className="margin-big-top"
        labelMap={labelMap}
      />
      <Switch>
        {routes}
        <Route path="/*" component={Home}/>
      </Switch>
      <SubLinks exclude={['/organisation']} excludeExact isEditable/>
      {/* <SubLinks exclude={['/organisation']}/> */}
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(OrganisationRoutes);
  